/*
 * DoneButton.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 04 2023 mys Company
 */

import { useState } from 'react'

const DoneButton = ({ label, type = 'button', buttonClassName, className, onClick, isDisabled = false }) => {
    // MARK: VARIABLE

    // MARK: METHOD

    const handleClick = () => {
        if (onClick) onClick()
    }

    return (
        <>
            <div className={` ${className ?? ''}`}>
                <button className={`w-full border  text-white bg-special1 rounded shadow-sm p-2 outline-none ${buttonClassName ?? ''}`} type={type} onClick={handleClick} disabled={isDisabled}>
                    {label}
                </button>
            </div>
        </>
    )
}

export default DoneButton
